<app-heading [title]="pageTitle" [isbreadcrumb]="false" [showToggle]="false"></app-heading>
<div class="col-12 md:col-12 sm:col-12 flex md:justify-content-end justify-content-between mt-3 md:mt-0 align-items-start sm:align-items-center  md:gap-4 gap-0 actions-header">
    @if(expiredCredentialsCandidateView){
        <div class="switch-w-label pt-2  flex gap-2">
            <label for="staffed" class="line-height-2">All</label>
            <p-inputSwitch [(ngModel)]="filterStaffedCandidates" (click)="onExpiredStaffedFilterToggleSwitch()"
                class="mpl-switch" inputId="staffed" ariaLabel="Currently Staffed" />
            <label for="staffed" class="line-height-2">{{'Currently Staffed' | sentenceCase}}</label>
        </div>
    }
    @if(userObject && userObject.firm.expiredCredentialApproval && !userObject.firm.reviewerAutoApproval && !expiredCredentialsCandidateView){
        <p-button (click) = "gotoCredentials()"  [label]="'Expired Credentials' | sentenceCase" [rounded]="true" [icon]="'x'"
            size="large" />
    }
</div>
@if(expiredCredentialsCandidateView){
    <ng-container *ngTemplateOutlet="candidateTable; context: { 
        data: reviewers, 
        totalRecords: reviewerCount, 
        loadFunction: 'getReviewers' 
    }"></ng-container>
}
@else {
    @if(userObject.firm.firmCredentialManualApproval){
        <p-tabView styleClass="full-w">
            <p-tabPanel header="NEW CANDIDATES">
                <ng-container *ngTemplateOutlet="candidateTable; context: { 
                    data: reviewers, 
                    totalRecords: reviewerCount, 
                    loadFunction: 'getReviewers' 
                }"></ng-container>
            </p-tabPanel>
        
            <p-tabPanel header="NEW CREDENTIALS">
                <ng-container *ngTemplateOutlet="candidateTable; context: { 
                    data: newCredentialReviewers, 
                    totalRecords: newCredentialReviewerCount, 
                    loadFunction: 'getNewCredentialReviewersList' 
                }"></ng-container>
            </p-tabPanel>
        </p-tabView>
    }
    @else {
        <ng-container *ngTemplateOutlet="candidateTable; context: { 
            data: reviewers, 
            totalRecords: reviewerCount, 
            loadFunction: 'getReviewers' 
        }"></ng-container>
    }

}

<!-- Reusable Table Template -->
<ng-template #candidateTable let-data="data" let-totalRecords="totalRecords" let-loadFunction="loadFunction">
    <div class="projects-data">
        <div class="grid grid-nogutter">
            <div class="col-12 p-0">
                <div class="data-table">
                    <p-table styleClass="p-datatable-sm p-datatable-sm--normal"
                        [value]="data" 
                        [lazy]="true"
                        [rows]="10"
                        [paginator]="true"
                        [totalRecords]="totalRecords"
                        (onLazyLoad)="handleLazyLoad($event, loadFunction)"
                        [showCurrentPageReport]="true" 
                        [tableStyle]="{ 'min-width': '50rem' }"
                        currentPageReportTemplate="Showing {first} - {last} of {totalRecords}"
                        autoLayout="true"
                        [scrollable]="true">
                        
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width:20%">Name</th>
                                <th style="width:20%">Email</th>
                                <th>Rating</th>                                        
                                @if (helperService.checkResponsive()) {
                                    <th style="width: 15%;" alignFrozen="right" pFrozenColumn>
                                        Actions
                                    </th>
                                } @else {
                                    <th>Actions</th>
                                }
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-reviewer>
                            <tr>
                                <td>
                                    <span class="cursor-pointer" (click)="openReviewerDialog(reviewer._id)">
                                        {{reviewer.firstName}} {{reviewer.lastName}}
                                    </span>
                                </td>
                                <td>{{reviewer.email}}</td>
                                <td>
                                    <p-rating [(ngModel)]="reviewer.defaultTenantRating" [readonly]="true" [cancel]="false" class="cursor-default"/>
                                </td>   
                                @if (helperService.checkResponsive()) {
                                    <td alignFrozen="right" pFrozenColumn>
                                        <ng-container *ngTemplateOutlet="actionButtons; context: { reviewer: reviewer }"></ng-container>
                                    </td>
                                } @else {
                                    <td>
                                        <ng-container *ngTemplateOutlet="actionButtons; context: { reviewer: reviewer }"></ng-container>
                                    </td>
                                }
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- Reusable Action Buttons Template -->
<ng-template #actionButtons let-reviewer="reviewer">
    <div class="flex gap-1 w-fit">                   
        @if(userObject.firm.firmCredentialManualApproval){
            <p-button (click)="showInfoDialog($event,reviewer)" [rounded]="true" [text]="true" icon="true">
                <span class="{{helperService.getEnvironmentName()}}-icon icon-info-outlined"></span>
            </p-button>
        }     
        @if(!expiredCredentialsCandidateView){
            <p-button (click)="approveReviewer($event,reviewer)" [rounded]="true" [text]="true" icon="true">
                <span class="{{helperService.getEnvironmentName()}}-icon icon-select-check-box-outlined"></span>
            </p-button>
            <p-button [pTooltip]="'Archive'" tooltipPosition="top" (click)="showDeleteReviewerConfirmation($event,reviewer)" [rounded]="true" [text]="true" icon="true">
                <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
            </p-button>
        }
    </div>
</ng-template>



